module.exports = __webpack_public_path__ + "img/hosting2.c8cbd89c.png";